import getToggle from '@config/toggleConfig';

const isDevelopment = getToggle({ local: true, dev: true, staging: false, pro: false });
const shouldRunDatalayer = getToggle({ local: false, dev: false });

type BaseDataLayerT = { [K: string]: unknown };
export type DataLayerPlanType = 'Estandar' | 'Premium';
export const SALE_WITH_AGENT_MAP = {
  true: 'Si',
  false: 'No',
};

export const PLAN_CODE_MAP = {
  premium: 'Premium',
  standard: 'Estandar',
};

export const BaseDataLayer = ({ eventParams }: BaseDataLayerT): void => {
  if (shouldRunDatalayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'vpv',
      event_params: eventParams,
    });
  }

  if (isDevelopment) {
    console.log({
      event: 'vpv',
      event_params: eventParams,
    });
  }
};
